export type BreadcrumbCrumb = {
  name: string
  url: string
}

export const BASE_URL = 'https://signoz.io'
